function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#282828;}.cls-2,.cls-3{fill:none;stroke:#fff;stroke-miterlimit:10;}.cls-2{stroke-width:7px;}.cls-3{stroke-width:5px;}"));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Ebene_2",
  "data-name": "Ebene 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Ebene_1-2",
  "data-name": "Ebene 1"
}, /*#__PURE__*/React.createElement("ellipse", {
  id: "ac0f3c55-8620-42ec-8b6b-17ee3b6979fd",
  className: "cls-1",
  cx: 51,
  cy: 50.5,
  rx: 51,
  ry: 50.5
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M61.64,61.91h6.2a11,11,0,0,0,0-22.07A16.6,16.6,0,0,0,35.5,37.16a12.51,12.51,0,0,0,.13,25H41"
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-3",
  x1: 51,
  y1: 48.3,
  x2: 51,
  y2: 75.62
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-3",
  x1: 52.73,
  y1: 44.39,
  x2: 43.63,
  y2: 53.68
}), /*#__PURE__*/React.createElement("line", {
  className: "cls-3",
  x1: 49.27,
  y1: 44.39,
  x2: 58.37,
  y2: 53.68
})));

const SvgSave = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 102 101",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSave, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/save.95ce40bf.svg";
export { ForwardRef as ReactComponent };